import { render } from "./HomePage.vue?vue&type=template&id=7f546c09"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\CONSULT\\PROJECTS\\_HTML\\baden-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__